const ScrollLink = ((($) => {
  let scroller;
  let show_more_btn;
  let concept_id;
  let next_concept;

  function init() {
    scroller = $('.scroll-to');
    show_more_btn = $('.show-more');
    _attachEvents();
    $('.listing-controls a').on('click', function(e) {
      e.preventDefault();
      $('.listing-controls .active').removeClass('active');
      $(this).addClass('active');
      $('.listing-items .show').removeClass('show');
      $('.listing-items').find('[data-list="'+ $(this).attr('data-listing') +'"]').addClass('show');
    });
  }

  function _attachEvents() {
    scroller.click(_handleClickLink);
    show_more_btn.click(function(e) {
      e.preventDefault();
      concept_id = $(this).parents('.Concept').data('concept');
      next_concept = concept_id+1;
      $('.Concept-box').find('*[data-concept="' + next_concept + '"]').slideDown('fast');
      $(this).css('opacity', '0');
    });
  }

  function _handleClickLink(e) {
    e.preventDefault();
    const id  = $(this).attr('href');
    const top = $(id).offset().top-40;
    $('.Header_nav-mobile').removeClass('show');
    $('body,html').animate({scrollTop: top}, 800);
  }

  return {
    init,
  };

}))(jQuery);

export default ScrollLink;



// WEBPACK FOOTER //
// ./src/static/js/modules/scroll-link.js